module.exports = __webpack_public_path__ + "img/header-weddingRingsNaturalBeige@2x.9eee75f.webp";